import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconsModule } from '../../design/icons.module';
import { FormAlertComponent } from './form-alert.component';
import { FormValidationComponent } from './form-validation.component';

@NgModule({
  declarations: [FormAlertComponent, FormValidationComponent],
  imports: [CommonModule, IconsModule],
  exports: [FormAlertComponent, FormValidationComponent]
})
export class FormValidationModule {}
